import { render, staticRenderFns } from "./epa-factors.vue?vue&type=template&id=383d2db2&scoped=true"
import script from "./epa-factors.vue?vue&type=script&lang=js"
export * from "./epa-factors.vue?vue&type=script&lang=js"
import style0 from "./epa-factors.vue?vue&type=style&index=0&id=383d2db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d2db2",
  null
  
)

export default component.exports